import React, { FC } from 'react';

export interface ILoanNumberOptions {
    id: string;
    value?: number | string;
    required: boolean;
    isValid: boolean;
    onChange(loanNumber: string): void;
    disabled: boolean;
}

export const LoanNumber: FC<ILoanNumberOptions> = ({
    id = 'loanNumber',
    value = '',
    onChange,
    required = false,
    isValid = true,
    disabled = false,
}) => {
    const setLoanNumber = (input) => {
        let cleanedInput = input.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');
        if (!cleanedInput || cleanedInput === '0' || isNaN(cleanedInput)) {
            cleanedInput = '';
        } else {
            cleanedInput = parseInt(cleanedInput).toString();
        }
        onChange(cleanedInput);
    };

    return (
        <input
            className={!isValid ? 'not-valid' : undefined}
            type='text'
            value={value ?? ''}
            id={id}
            onChange={(event) => setLoanNumber(event.target.value)}
            maxLength={8}
            required={required}
            disabled={disabled}
        />
    );
};
